import React from 'react';

// PROD-7828 R5b — a failed read says so and offers a retry; it never falls through to an empty or
// all-zero state that reads like real data (HM2).
const LoadFailed = ({ text, on_retry }) => (
  <div className="tp-banner tp-banner-error" role="alert">
    {text}{' '}
    <button type="button" className="tp-link" onClick={on_retry}>
      Try again
    </button>
  </div>
);

export default LoadFailed;
